import React, { useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getAuthState } from "@redriver/cinnamon";
import { AppRoutes, SystemRoutes } from "constants/routes";
import { SystemPageContent } from "components/pages";
import { AuthenticatorCheck, AuthenticatorSetup } from "features/System";

const AuthenticationPage = ({ loggedIn, location }) => {
  const {
    registeredTypes,
    availableTypes,
    recoveryTypes,
    token,
    loginTokens,
    enforceMfa,
    userEmail,
  } = location.state ?? {};

  const totpAvailable = availableTypes?.includes("TOTP");
  const totpRegistered = registeredTypes?.includes("TOTP");

  const [recovered, setRecovered] = useState(false);
  const [skipped, setSkipped] = useState(false);

  const setupRequired = (!totpRegistered || recovered) && !skipped;
  const setupRecovery = !recovered && (recoveryTypes ?? []).length === 0;

  if (!setupRequired && loggedIn) {
    return <Redirect to={AppRoutes.Root} />;
  }

  if (!token || !totpAvailable) {
    return <Redirect to={SystemRoutes.Login} />;
  }

  return (
    <SystemPageContent title="Multi-Factor Authentication">
      {!setupRequired ? (
        <AuthenticatorCheck
          token={token}
          recoveryTypes={recoveryTypes}
          onRecovered={() => setRecovered(true)}
        />
      ) : (
        <AuthenticatorSetup
          token={token}
          setupRecovery={setupRecovery}
          email={userEmail}
          loginTokens={loginTokens}
          enforceMfa={enforceMfa}
          onSkipped={() => setSkipped(true)}
        />
      )}
    </SystemPageContent>
  );
};

const mapStateToProps = (state) => {
  const { loggedIn } = getAuthState(state);
  return { loggedIn };
};

export default connect(mapStateToProps)(AuthenticationPage);
